import React from 'react';
import Layout from '../../engine/layout';
import { Typography } from 'antd';
import { FilePdfOutlined, LinkOutlined } from '@ant-design/icons';

class Cooperation extends Layout {
    constructor(props) {
        super(props);

        this.app = props.app;
        this.links = [
            {
                key: `KLATIENES_TURNIRA_PIEDAVAJUMS`,
                href: `files/KLATIENES_TURNIRA_PIEDAVAJUMS`,
                type: `pdf`,
                title: `Klātienes zolītes turnīra rīkošanas piedāvājums`,
            },
            {
                key: `TIESSAISTES_TURNIRA_PIEDAVAJUMS`,
                href: `files/TIESSAISTES_TURNIRA_PIEDAVAJUMS`,
                type: `pdf`,
                title: `Tiešsaistes zolītes turnīra rīkošanas piedāvājums`,
            },
            {
                key: `analytics`,
                href: `analytics`,
                type: `link`,
                title: `Mājas lapas statistika`,
            },
        ];
    }

    componentDidMount() {
        this.app = this.props.app;
    }
    
    componentDidUpdate() {
        this.app = this.props.app;
    }

    content (layout = `desktop`) {
        if (layout === `desktop`) {
            return this.contentWide();
        }

        return this.contentMobile();
    }

    head() {
        return (
            <div style={{
                position: `absolute`,
                height: `max(25vh, 300px)`,
                top: 0,
                left: 0,
                right: 0,
            }}>
                <Typography.Title
                    level={2}
                    style={{
                        color: `#F3DD8E`,
                        fontSize: 36,
                        margin: `4vh 0 30px 0`,
                        textAlign: `center`
                    }}
                >
                    Sadarbība
                </Typography.Title>
            </div>
        );
    }

    contentMobile() {
        return (
            <>
                <div style={{ height: 50, width: `100%` }} />
                {
                    this.links.map((item) => (
                        <>
                            <Typography.Link
                                key={item.key}
                                onClick={() => {
                                    if (item.type === `pdf`) {
                                        window.open(`${document.location.origin}/${item.href}`);
                                    } else {
                                        this.app.fn.navigate(item.href, item.title);
                                    }
                                }}
                                style={{
                                    cursor: `alias`,
                                    textTransform: `uppercase`,
                                    margin: `5px 0`,
                                    display: `inline-block`,
                                    marginLeft: 40,
                                }}
                            >
                                {item.title}
                                {item.type === `pdf` ? (
                                    <FilePdfOutlined className="pdf-icon" />
                                ) : (
                                    <LinkOutlined className="pdf-icon" />
                                )}
                            </Typography.Link>
                            <br />
                        </>
                    ))
                }
            </>
        );
    }

    contentWide() {
        return (
            <>
                <Typography.Title level={2}>Sadarbība</Typography.Title>
                {
                    this.links.map((item) => (
                        <>
                            <Typography.Link
                                key={item.key}
                                onClick={() => {
                                    if (item.type === `pdf`) {
                                        window.open(`${document.location.origin}/${item.href}`);
                                    } else {
                                        this.app.fn.navigate(item.href, item.title);
                                    }
                                }}
                                style={{
                                    cursor: `alias`,
                                    textTransform: `uppercase`,
                                    margin: `5px 0`,
                                    display: `inline-block`,
                                    marginLeft: 40,
                                }}
                            >
                                {item.title}
                                {item.type === `pdf` ? (
                                    <FilePdfOutlined className="pdf-icon" />
                                ) : (
                                    <LinkOutlined className="pdf-icon" />
                                )}
                            </Typography.Link>
                            <br />
                        </>
                    ))
                }
            </>
        );
    }
}

export default Cooperation;
